// utils/multiEje.js — P2b tanda 7d. ESPEJO de backend/utils/multiEje.js (no
// comparten runtime, como colTime): ejes de variación del padre y predicado
// multi-eje; acá vive además el nombre COMPUESTO de una variación («Negro · S»)
// — con attributes[0] un Color × Talla mostraba tres filas «Negro» idénticas.
// Si el criterio del predicado cambia, cambia en los dos espejos.
export function ejesDeVariacion(attributes) {
  return (Array.isArray(attributes) ? attributes : []).filter((a) => a && a.variation);
}

export function esMultiEje(attributes) {
  return ejesDeVariacion(attributes).length > 1;
}

// attributes de UNA variación → «Negro · S» (vacíos afuera; un solo eje → su valor).
export function opcionCompuesta(vAttributes) {
  return (Array.isArray(vAttributes) ? vAttributes : [])
    .map((a) => String((a && a.option) || '').trim())
    .filter(Boolean)
    .join(' · ');
}
